import * as React from "react";
import { FormGroup, Input } from "reactstrap";
import { useTranslation } from "react-i18next";
import { AlertOnErrors } from "../../shared/alertOnErrors";
import { useProfileForInvite } from "../../api/main/profiles/useProfileForInvite";

/**
 * Allow the user to set their personal details on their profile during registration.
 */
export const ConfirmInviteProfileDetails = () => {
    const { t } = useTranslation();

    const { data: { model }, errors: loadingErrors } = useProfileForInvite();

    // Render the UI.
    //
    return (
        <>
            <AlertOnErrors errors={loadingErrors} />

            <FormGroup>
                <Input placeholder={t('confirmInviteProfileDetails.firstName', 'First name')} name="firstName" type="text" value={model?.firstName ?? ''} readOnly />
            </FormGroup>
            <FormGroup>
                <Input placeholder={t('confirmInviteProfileDetails.lastName', 'Last name')} name="lastName" type="text" value={model?.lastName ?? ''} readOnly />
            </FormGroup>
            <FormGroup>
                <Input placeholder={t('confirmInviteProfileDetails.email', 'Email')} name="lastName" type="email" value={model?.user?.email ?? ''} readOnly />
            </FormGroup>
        </>
    );
};
